





















import Vue from 'vue';
import {AppModuleConfig} from '../models/AppModuleConfig';
import AppModuleNav from './AppModuleNav.vue';
import commonVuex from '../vuex/common';

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    AppModuleNav,
  },
  props: ['module'],
  data() {
    return {
      currentAlias: '',
      contentHeight: 'auto',
    };
  },
  computed: {
    moduleStyles(): any {
      return {
        paddingTop: `${this.module.description ? 143 : 112}px`,
      };
    },
    contentStyles(): any {
      return {
        height: this.contentHeight,
      };
    },
  },
  methods: {
    getCurrentPage(path: string): string {
      const r = path.split('/');
      if (r && r.length >= 3) {
        return r[2];
      } else {
        return '';
      }
    },
    setContentHeight() {
      if (this.$refs.navs) {
        const height = window.document.body.offsetHeight - (this.$refs.navs as any).$el.clientHeight;
        this.contentHeight = `${height}px`;
      }
    },
  },
  mounted() {
    this.currentAlias = this.getCurrentPage(this.$route.path);
    window.addEventListener('resize', () => {
      this.setContentHeight();
    });
    this.$nextTick(() => {
      this.setContentHeight();
    });
  },
  watch: {
    $route(to, from) {
      this.currentAlias = this.getCurrentPage(to.fullPath);
    },
  },
});
